import { render } from "./StatsChatFallback.vue?vue&type=template&id=4de3e956&scoped=true"
import script from "./StatsChatFallback.vue?vue&type=script&lang=js"
export * from "./StatsChatFallback.vue?vue&type=script&lang=js"

import "./StatsChatFallback.vue?vue&type=style&index=0&id=4de3e956&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de3e956"]])

export default __exports__